import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { N20 } from '@atlaskit/adf-schema';
import { Box, xcss } from '@atlaskit/primitives';
import Select from '@atlaskit/select';
import { DisplayMode } from '../../../RenderForm';
import { ViewWrapper } from '../../common/questionWrappers';
var styles = {
  control: function control(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      backgroundColor: "var(--ds-background-accent-gray-subtlest, ".concat(N20, ")"),
      borderColor: "var(--ds-border-disabled, #DFE1E6)",
      color: "var(--ds-text, #172B4D !important)"
    });
  },
  menu: function menu(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      color: "var(--ds-text, #172B4D)"
    });
  }
};
var containerStyles = xcss({
  display: 'flex',
  flexDirection: 'row'
});
var parentStyles = xcss({
  width: '50%',
  marginRight: 'space.100'
});
var childStyles = xcss({
  width: '50%'
});
export var ViewCascadingDropdown = function ViewCascadingDropdown(_ref) {
  var id = _ref.id,
    value = _ref.value,
    childValue = _ref.childValue,
    displayMode = _ref.displayMode;
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    // The Select displays as disabled in these modes
    return /*#__PURE__*/React.createElement(Box, {
      xcss: containerStyles
    }, /*#__PURE__*/React.createElement(Box, {
      xcss: parentStyles
    }, /*#__PURE__*/React.createElement(Select, {
      id: id,
      value: value,
      placeholder: "",
      isDisabled: true,
      styles: styles
    })), /*#__PURE__*/React.createElement(Box, {
      xcss: childStyles
    }, /*#__PURE__*/React.createElement(Select, {
      id: id,
      value: childValue,
      placeholder: "",
      isDisabled: true,
      styles: styles
    })));
  }
  return /*#__PURE__*/React.createElement(ViewWrapper, null, value ? "".concat(value.label) + (childValue ? " - ".concat(childValue.label) : '') : '');
};